import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';

import classes from './SubHeader.scss';

export const OrderTrackingIcon: React.FC<{ whiteIcons: boolean }> = ({ whiteIcons }) => (
    <Link to="/order-tracking" className={classnames({ [classes.whiteIcons]: whiteIcons })}>
        <img src={require('../../../static/icons/aim-checkout.svg')} alt="aim icon" />
        <span>Track order</span>
    </Link>
);
